import {
  GET_TAX_REGIMES
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_TAX_REGIMES] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/taxRegimes.js